import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import BlogForm from "./BlogForm";
import { getBlogById, updateBlog } from "../../api/BlogService";

const BlogEdit = () => {
  const location = useLocation();
  const id = location.state?.blogId;
  const slug = location.state.blogslug;

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    loadBlog();
  }, [id]);

  const loadBlog = async () => {
    try {
      const res = await getBlogById(slug);

      setBlog({
        _id: res.data._id,
        title: res.data.title || "",
        excerpt: res.data.excerpt || "",
        category: res.data.category?._id || res.data.category || "",
        author: res.data.author?._id || res.data.author || "",
        publishedDate: res.data.publishedDate || "",
        readingTime: res.data.readingTime || 0,
        content: res.data.content || "",
        status: res.data.status || "ACTIVE",
      });
    } catch (error) {
      console.error("Get Blog Error", error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const payload = {
        title: values.title,
        excerpt: values.excerpt,
        category: values.category,
        author: values.author,
        publishedDate: values.publishedDate,
        readingTime: Number(values.readingTime),
        content: values.content,
        status: values.status,
      };

      const res = await updateBlog(id, payload);

      if (res.success) {
        navigate("/blog");
      }
    } catch (error) {
      console.error("Update Error", error);
    } finally {
      setLoading(false);
    }
  };

  if (!blog) {
    return <p>Loading...</p>;
  }

  return (
    <BlogForm
      blog={blog}
      initialValues={blog}
      onSubmit={handleSubmit}
      loading={loading}
      onCancel={() => navigate("/blog")}
    />
  );
};

export default BlogEdit;
